export const common = {
      language: 'Idioma',
      pagination: {
        previous: 'Anterior',
        next: 'Siguiente',
        pageOf: 'Página {{page}} de {{totalPages}}',
        itemsPerPage: 'Ítems por página',
      },
      loading: {
        title: 'Cargando registros',
        description: 'Estamos obteniendo la información más reciente.',
        errorTitle: 'No pudimos cargar la información',
      },
      movementDirections: {
        in: 'Entrada',
        out: 'Salida',
        adjustment: 'Ajuste',
        transfer: 'Transferencia',
      },
      unitTypes: {
        piece: 'Pieza',
        package: 'Empaque',
        weight: 'Peso',
        volume: 'Volumen',
        length: 'Longitud',
        area: 'Area',
      },
      actions: {
        add: 'Agregar',
        select: 'Seleccionar',
        refresh: 'Refrescar',
        edit: 'Editar',
        delete: 'Eliminar',
        save: 'Guardar',
        update: 'Actualizar',
        close: 'Cerrar',
        cancel: 'Cancelar',
      },
      emptyStates: {
        noResultsTitle: 'Sin resultados',
        noResultsDescription: 'No hay registros para los filtros actuales.',
      },
      filters: {
        all: 'Todos',
      },
      validation: {
        required: 'Este campo es obligatorio.',
        email: 'Ingresa un correo válido.',
        duplicate: 'Este valor ya existe.',
        duplicateCode: 'Este código ya existe.',
        duplicateEmail: 'Este correo ya existe.',
        duplicateName: 'Este nombre ya existe.',
        duplicateSymbol: 'Este símbolo ya existe.',
        duplicateCombination: 'Esta combinación ya existe.',
        distinctPackagingUnits: 'La presentación y la unidad contenida deben ser diferentes.',
        systemManagedDelete: 'Los registros del sistema no se pueden eliminar.',
        systemManagedUpdate: 'Los registros del sistema no se pueden editar.',
        maxLength: 'Máximo {{count}} caracteres.',
        minLength: 'Mínimo {{count}} caracteres.',
        invalidFormat: 'Formato inválido.',
        minValue: 'Ingresa un valor mayor o igual a {{count}}.',
        maxValue: 'Ingresa un valor menor o igual a {{count}}.',
        requestFailed: 'No se pudieron guardar los cambios.',
      },
      labels: {
        id: 'ID',
        code: 'Código',
        name: 'Nombre',
        contactName: 'Contacto',
        customerType: 'Tipo de cliente',
        symbol: 'Símbolo',
        description: 'Descripción',
        unitType: 'Tipo',
        allowsDecimals: 'Decimales',
        product: 'Producto',
        client: 'Cliente',
        packageUnit: 'Unidad de empaque',
        presentationUnit: 'Presentación',
        referenceUnit: 'Contiene',
        referenceQuantity: 'Cantidad',
        baseUnit: 'Unidad base',
        averageCost: 'Costo promedio',
        quantity: 'Cantidad',
        pieces: 'Piezas',
        quantityInBaseUnit: 'Cantidad en unidad base',
        inventoryValue: 'Valor inventario',
        purchaseUnit: 'Se compra en',
        saleUnit: 'Se vende',
        defaultPurchase: 'Compra predeterminada',
        defaultSale: 'Venta predeterminada',
        costingUnit: 'Se costea en',
        direction: 'Dirección',
        email: 'Correo',
        phone: 'Teléfono',
        addressLine1: 'Dirección',
        city: 'Ciudad',
        state: 'Estado',
        country: 'País',
        postalCode: 'Código postal',
        paymentTerms: 'Términos de pago',
        taxId: 'RFC',
        market: 'Mercado',
        role: 'Rol',
        status: 'Estatus',
        active: 'Estatus',
        lastAccess: 'Último acceso',
        actions: 'Acciones',
        affectsInventory: 'Afecta inventario',
        associatesWithClient: 'Asocia con cliente',
        requiresReference: 'Requiere referencia',
        reference: 'Referencia',
        system: 'Sistema',
        date: 'Fecha',
        createdDate: 'Registrado el',
        createdBy: 'Registrado por',
        updatedDate: 'Actualizado el',
      },
      values: {
        yes: 'Si',
        no: 'No',
        activeStatus: 'Activo',
        inactiveStatus: 'Inactivo',
        marketMx: 'México',
        marketUs: 'USA',
        marketCa: 'Canadá',
      },
    } as const;
